import crypto from 'crypto';
import { PR_KEY } from '../../env';
const secret = PR_KEY;

function generateKey() {
  const now = new Date();
  now.setMinutes(now.getMinutes() + 1, 0, 0);
  const key = now.getTime().toString();
  const fullKey = secret + key;
  return crypto.createHash('sha256').update(fullKey).digest();
}

export function decryptData(message) {
  const data = Buffer.from(message, 'base64');
  const iv = data.slice(0, 12);
  const authTag = data.slice(data.length - 16);
  const encryptedText = data.slice(12, data.length - 16);

  const key = generateKey();
  const decipher = crypto.createDecipheriv('aes-256-gcm', key, iv);
  decipher.setAuthTag(authTag);

  let decrypted = decipher.update(encryptedText, 'base64', 'utf8');
  decrypted += decipher.final('utf8');

  return decrypted;
}
